import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

export const getAllDocuments = () =>
  apiClient.get(REST_API_BASE_URL + '/documents');

export const saveDocument = (document) =>
  apiClient.post(REST_API_BASE_URL + '/document', document);

export const getDocument = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/document/${id}`);

export const updateDocument = (id, document) =>
  apiClient.put(`${REST_API_BASE_URL}/document/${id}`, document);

export const deleteDocument = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/document/${id}`);

export default apiClient;
